<template>
	<div class="buildingRallypointOverview troopsTable scrollable">
		<div class="scrollContentOuterWrapper">
			<div class="scrollContent" style="overflow-y: auto;">
				<div class="scrollContentInnerWrapper" style="width: auto;">
					<h4 ng-if="troopsOverview.troopsCount.Deployed == 0">
						<span>У тебя нет войск за пределами деревни.</span>
					</h4>
					<h4 ng-if="troopsOverview.troopsCount.Deployed > 0" translate="" data="count:1"><span>Войска в подкреплении: (1)</span></h4>
					<div ng-repeat="troopDetails in troopsOverview.displayTroops.Deployed">
						<troop-details-rallypoint troop-details="troopDetails" send-troops="sendTroops(troops, type);">
							<div class="troopsDetailContainer">
								<div class="troopsDetailHeader" ng-if="!showInputFields">
									<!-- ngIf: status == 'send' -->
									<!-- ngIf: isGroup -->
									<div class="troopsTitle" ng-if="status != 'send' && !isGroup">
										<!-- ngIf: status == 'home' && troopDetails.tribeId != tribes.NATURE -->
										<!-- ngIf: status == 'nature' -->
										<!-- ngIf: status == 'support' -->
										<!-- ngIf: status == 'oasisSupport' -->
										<!-- ngIf: status == 'ownSupport' -->
										<div ng-if="status == 'awaySupport'">
											<span translate="" data="villageId: 536264692, villageName: , playerId: 734, playerName: "><span>В </span><a ng-class="{disabled: villId <= 2 || nolink}" class="truncated villageLink truncated clickable" clickable="$root.openWindow('mapCellDetails', {'cellId': 536264692}, null, true)" villageid="536264692" villagename="" nolink="" showmissinglink="true">Зарница</a><span> игрока </span><a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="truncated playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" playerid="734" playername="lexinzector" nolink="" showmissinglink="true">lexinzector</a></span>
										</div>
										<!-- ngIf: status == 'homeTrap' -->
										<!-- ngIf: status == 'awayTrap' -->
										<!-- ngIf: status == 'incoming' -->
										<!-- ngIf: status == 'outgoing' -->
									</div>
									<div class="troopsInfo awaySupportInfo" ng-if="status != 'send'">
										<!-- ngIf: troopDetails.movement.recurrencesTotal > 1 -->
										<!-- ngIf: troopDetails.status == 'transit' -->
										<div ng-if="(troopDetails.status != 'transit' && troopDetails.status != 'trap' && troopDetails.status != 'send' && troopDetails.tribeId != tribes.NATURE) || (troopDetails.status == 'trap' && troopDetails.playerId == $root.player.data.playerId)" tooltip="" tooltip-translate="Resource.CropConsumption">
											<span class="text"><i class="unit_consumption_small_flat_black"></i> 136 <span translate=""><span>в час</span></span></span>
										</div>
										<!-- ngIf: status == 'incoming' -->
									</div>
								</div>
								<div troops-details="" ng-if="showUnits" troop-data="troopDetails" render-lazy="false">
									<table class="troopsTable gaul">
										<tbody class="troopsIconRow">
											<tr>
												<td ng-repeat="n in []|range:1:11" class="unit1">
													<i class="unitSmall gaul unitType1 inactive" unit-icon="" data="21" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																					|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
																		clickable: unitIconCallback}" tooltip="" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
													<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
													<div class="horizontalLine" ng-if="troopData['originalTroops'] || !troopData['inputTroops']"></div>
												</td>
												<td ng-repeat="n in []|range:1:11" class="unit2">
													<i class="unitSmall gaul unitType2" unit-icon="" data="22" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																					|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
																		clickable: unitIconCallback}" tooltip="" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
													<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
													<div class="horizontalLine" ng-if="troopData['originalTroops'] || !troopData['inputTroops']"></div>
												</td>
												<td ng-repeat="n in []|range:1:11" class="unit3">
													<i class="unitSmall gaul unitType3 inactive" unit-icon="" data="23" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																					|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
																		clickable: unitIconCallback}" tooltip="" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
													<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
													<div class="horizontalLine" ng-if="troopData['originalTroops'] || !troopData['inputTroops']"></div>
												</td>
												<td ng-repeat="n in []|range:1:11" class="unit4">
													<i class="unitSmall gaul unitType4 inactive" unit-icon="" data="24" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																					|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
																		clickable: unitIconCallback}" tooltip="" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
													<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
													<div class="horizontalLine" ng-if="troopData['originalTroops'] || !troopData['inputTroops']"></div>
												</td>
												<td ng-repeat="n in []|range:1:11" class="unit5">
													<i class="unitSmall gaul unitType5" unit-icon="" data="25" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																					|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
																		clickable: unitIconCallback}" tooltip="" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
													<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
													<div class="horizontalLine" ng-if="troopData['originalTroops'] || !troopData['inputTroops']"></div>
												</td>
												<td ng-repeat="n in []|range:1:11" class="unit6">
													<i class="unitSmall gaul unitType6" unit-icon="" data="26" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																					|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
																		clickable: unitIconCallback}" tooltip="" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
													<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
													<div class="horizontalLine" ng-if="troopData['originalTroops'] || !troopData['inputTroops']"></div>
												</td>
												<td ng-repeat="n in []|range:1:11" class="unit7">
													<i class="unitSmall gaul unitType7 inactive" unit-icon="" data="27" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																					|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
																		clickable: unitIconCallback}" tooltip="" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
													<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
													<div class="horizontalLine" ng-if="troopData['originalTroops'] || !troopData['inputTroops']"></div>
												</td>
												<td ng-repeat="n in []|range:1:11" class="unit8">
													<i class="unitSmall gaul unitType8 inactive" unit-icon="" data="28" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																					|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
																		clickable: unitIconCallback}" tooltip="" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
													<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
													<div class="horizontalLine" ng-if="troopData['originalTroops'] || !troopData['inputTroops']"></div>
												</td>
												<td ng-repeat="n in []|range:1:11" class="unit9">
													<i class="unitSmall gaul unitType9 inactive" unit-icon="" data="29" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																					|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
																		clickable: unitIconCallback}" tooltip="" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
													<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
													<div class="horizontalLine" ng-if="troopData['originalTroops'] || !troopData['inputTroops']"></div>
												</td>
												<td ng-repeat="n in []|range:1:11" class="unit10">
													<i class="unitSmall gaul unitType10 inactive" unit-icon="" data="30" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																					|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
																		clickable: unitIconCallback}" tooltip="" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
													<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
													<div class="horizontalLine" ng-if="troopData['originalTroops'] || !troopData['inputTroops']"></div>
												</td>
												<td ng-repeat="n in []|range:1:11" class="hero">
													<i class="unitSmall hero_illu inactive" unit-icon="" data="hero" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																					|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
																		clickable: unitIconCallback}" tooltip="" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
													<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
													<div class="horizontalLine" ng-if="troopData['originalTroops'] || !troopData['inputTroops']"></div>
												</td>
											</tr>
										</tbody>
										<tbody ng-if="troopData[troopsType+'Troops']" class="originalTroops" ng-repeat="troopsType in ['original', 'input', 'lost', 'trapped']">
											<!-- ngIf: troopsType == 'trapped' -->
											<tr>
												<td ng-repeat="n in [] | range:1:11" class="unit1">
													<span ng-if="troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0)">-</span>
													<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->
													<!-- ngIf: troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1 -->
													<!-- ngIf: troopsType == 'input' -->
												</td>
												<td ng-repeat="n in [] | range:1:11" class="unit2">
													<!-- ngIf: troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0) -->
													<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->
													<div ng-if="troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1">
														<!-- ngIf: troopsType == 'original' && troopData['inputTroops'] -->
														<span ng-if="(troopsType != 'original' || !troopData['inputTroops']) && !(troopsType == 'lost' && n == Troops.TYPE_HERO && troopData['heroHealthLoss'])">70</span>
														<!-- ngIf: troopsType == 'lost' && n == Troops.TYPE_HERO && troopData['heroHealthLoss'] -->
													</div>
													<!-- ngIf: troopsType == 'input' -->
												</td>
												<td ng-repeat="n in [] | range:1:11" class="unit3">
													<span ng-if="troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0)">-</span>
													<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->
													<!-- ngIf: troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1 -->
													<!-- ngIf: troopsType == 'input' -->
												</td>
												<td ng-repeat="n in [] | range:1:11" class="unit4">
													<span ng-if="troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0)">-</span>
													<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->
													<!-- ngIf: troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1 -->
													<!-- ngIf: troopsType == 'input' -->
												</td>
												<td ng-repeat="n in [] | range:1:11" class="unit5">
													<!-- ngIf: troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0) -->
													<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->
													<div ng-if="troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1">
														<!-- ngIf: troopsType == 'original' && troopData['inputTroops'] -->
														<span ng-if="(troopsType != 'original' || !troopData['inputTroops']) && !(troopsType == 'lost' && n == Troops.TYPE_HERO && troopData['heroHealthLoss'])">15</span>
														<!-- ngIf: troopsType == 'lost' && n == Troops.TYPE_HERO && troopData['heroHealthLoss'] -->
													</div>
													<!-- ngIf: troopsType == 'input' -->
												</td>
												<td ng-repeat="n in [] | range:1:11" class="unit6">
													<!-- ngIf: troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0) -->
													<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->
													<div ng-if="troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1">
														<!-- ngIf: troopsType == 'original' && troopData['inputTroops'] -->
														<span ng-if="(troopsType != 'original' || !troopData['inputTroops']) && !(troopsType == 'lost' && n == Troops.TYPE_HERO && troopData['heroHealthLoss'])">12</span>
														<!-- ngIf: troopsType == 'lost' && n == Troops.TYPE_HERO && troopData['heroHealthLoss'] -->
													</div>
													<!-- ngIf: troopsType == 'input' -->
												</td>
												<td ng-repeat="n in [] | range:1:11" class="unit7">
													<span ng-if="troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0)">-</span>
													<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->

													<!-- ngIf: troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1 -->
													<!-- ngIf: troopsType == 'input' -->
												</td>
												<td ng-repeat="n in [] | range:1:11" class="unit8">
													<span ng-if="troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0)">-</span>
													<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->

													<!-- ngIf: troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1 -->
													<!-- ngIf: troopsType == 'input' -->
												</td>
												<td ng-repeat="n in [] | range:1:11" class="unit9">
													<span ng-if="troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0)">-</span>
													<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->

													<!-- ngIf: troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1 -->
													<!-- ngIf: troopsType == 'input' -->
												</td>
												<td ng-repeat="n in [] | range:1:11" class="unit10">
													<span ng-if="troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0)">-</span>
													<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->

													<!-- ngIf: troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1 -->
													<!-- ngIf: troopsType == 'input' -->
												</td>
												<td ng-repeat="n in [] | range:1:11" class="hero">
													<span ng-if="troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0)">-</span>
													<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->

													<!-- ngIf: troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1 -->
													<!-- ngIf: troopsType == 'input' -->
												</td>
											</tr>
										</tbody>
										<!-- ngIf: troopData.supply -->
										<!-- ngIf: troopData.cagedAnimals -->
									</table>
								</div>
								<!-- ngIf: showCatapults || showSpy || showBounty -->
								<div class="troopActions" ng-if="isGroup || (showAction && !isGroup) || (showAbort && $root.currentServerTime <= abortButtonShowTime) || isAdventure">
									<!-- ngIf: isGroup -->
									<button ng-if="showAction && !isGroup" class="actionButton jsButtonSendTroopsBack clickable" clickable="sendBack();">
										<div class="content">
											<span ng-transclude="" class="innerText">
												<span translate="" options="Call"><span>Отозвать</span></span>
											</span>
											<!-- ngIf: price > 0 || forceGoldUsage -->
											<!-- ngIf: price == -1 && !forceGoldUsage -->
											<div class="animationOverlay"></div>
											<i class="checkmark action_check_small_flat_white"></i>
											<i class="checkmark action_check_small_flat_black"></i>
											<i class="checkmark action_check_small_flat_red"></i>
										</div>
									</button>
									<!-- ngIf: (showAbort && $root.currentServerTime <= abortButtonShowTime) || isAdventure -->
								</div>
							</div>
						</troop-details-rallypoint>
					</div>
				</div>
			</div>
		</div>
		<div pagination="" items-per-page="itemsPerPage" number-of-items="numberOfItems" current-page="currentPage" display-page-func="displayCurrentPage" route-named-param="cp">
			<div ng-transclude=""></div>
			<div class="tg-pagination ng-hide" ng-show="visible">
				<ul>
					<li class="firstPage clickable disabled" ng-class="{disabled: currentPage == 1}" clickable="firstPage()" on-pointer-over="beginningHover = true" on-pointer-out="beginningHover = false">
						<i ng-class="{
							action_toBeginning_tiny_flat_black: !beginningHover || (beginningHover && currentPage == 1),
							action_toBeginning_tiny_flat_green: beginningHover && currentPage != 1,
							disabled: currentPage == 1
						}" class="action_toBeginning_tiny_flat_black disabled"></i>
					</li>
					<li class="prevPage clickable disabled" ng-class="{disabled: currentPage == 1}" clickable="prevPage()" on-pointer-over="fromHover = true" on-pointer-out="fromHover = false">
						<i ng-class="{
							symbol_arrowFrom_tiny_flat_black: !fromHover || (fromHover && currentPage == 1),
							symbol_arrowFrom_tiny_flat_green: fromHover && currentPage != 1,
							disabled: currentPage == 1
						}" class="symbol_arrowFrom_tiny_flat_black disabled"></i>
					</li>
					<li class="number clickable disabled" ng-repeat="pageNumber in filteredPageNumbers track by $index" ng-class="{disabled: (currentPage == pageNumber || pageNumber == '...')}" clickable="setPage(1)">
						<a ng-class="{disabled: (currentPage == pageNumber || pageNumber == '...')}" class="disabled">1</a>
					</li>
					<li class="nextPage clickable disabled" ng-class="{disabled: disableNext()}" on-pointer-over="toHover = true" on-pointer-out="toHover = false" clickable="nextPage()">
						<i ng-class="{
							symbol_arrowTo_tiny_flat_black: !toHover || (toHover && disableNext()),
							symbol_arrowTo_tiny_flat_green: toHover && !disableNext(),
							disabled: disableNext()
						}" class="symbol_arrowTo_tiny_flat_black disabled"></i>
					</li>
					<li class="lastPage clickable disabled" ng-class="{disabled: disableNext()}" on-pointer-over="endHover = true" on-pointer-out="endHover = false" clickable="lastPage()">
						<i ng-class="{
							action_toEnd_tiny_flat_black: !endHover || (endHover && disableNext()),
							action_toEnd_tiny_flat_green: endHover && !disableNext(),
							disabled: disableNext()
						}" class="action_toEnd_tiny_flat_black disabled"></i>
					</li>
				</ul>
			</div>
		</div>
		<div class="error">xxx</div>
		<button class="sendTroops clickable" clickable="openWindow('sendTroops')">
			<div class="content">
				<span ng-transclude="" class="innerText">
					<span translate=""><span>Отправить войска</span></span>
				</span>
				<div class="animationOverlay"></div>
				<i class="checkmark action_check_small_flat_white"></i>
				<i class="checkmark action_check_small_flat_black"></i>
				<i class="checkmark action_check_small_flat_red"></i>
			</div>
		</button>
	</div>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';

export default {
	mixins: lib.mixins,
	data: () => ({
		
	}),
	computed: {},
	methods: {},
	components: {},
}
</script>